export enum NotificationType {
  Success = 'success',
  Danger = 'danger',
}

export type Notification = {
  id: number;
  type?: NotificationType;
  message: React.ReactNode;
  description?: React.ReactNode;
  onClose?: () => void;
  action?: {
    text: string;
    onClick: (notification: Notification) => void;
  };
  canExpire?: boolean;
};

export type NotificationPayload = Omit<Notification, 'id'>;

export type PushNotif = (input: NotificationPayload) => void;

export type DangerNotif = (
  message: React.ReactNode,
  description?: React.ReactNode,
) => void;

export type SuccessNotif = (
  message: React.ReactNode,
  description?: React.ReactNode,
) => void;
